module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/search-icon-ca9e83c239b22c93ca78ab6e9d4772e2.png";